import { z } from "zod";

export const baseSchema = z.object({
	lang: z.string(),
});

export const loginSchema = z.object({
	email: z.string().email(),
	password: z.string(),
});

export const forgotPasswordSchema = z.object({
	email: z.string().email().min(1),
});

export const resetPasswordSchema = z.object({
	id: z.string().min(1),
	resetPasswordToken: z.string().min(1),
	newPassword: z.string().min(8),
	confirmPassword: z.string().min(1),
});

export const createAccountSchema = z.object({
	firstname: z.string().min(1),
	lastname: z.string().min(1),
	email: z.string().email(),
	password: z.string().min(8),
	passwordConfirmation: z.string().min(1),
});
